var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('widget',{attrs:{"id":'revenue-pie',"headless":true,"title":_vm.$tc('phrases.revenuePerCustomerType'),"color":"red"}},[(_vm.loading)?_c('div',[_c('loader',{attrs:{"size":"sm"}})],1):_c('div',[_c('GChart',{attrs:{"type":"PieChart","options":_vm.donutChartOptions,"data":_vm.donutData}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }